import React, { type ReactNode } from 'react';
import Tooltip from '@atlaskit/tooltip';
import VisuallyHidden from '@atlaskit/visually-hidden';
import type { addRequestTypeDropdownQuery } from './__generated_apollo__/addRequestTypeDropdownQuery';

export const transformGiraReponseToHasReachedFieldLimits = (
	data: addRequestTypeDropdownQuery | undefined,
) => {
	if (data?.projectConfiguration?.__typename === 'JiraProjectConfigurationResult') {
		const fieldsLimit = data?.projectConfiguration.limitInfo?.limitFieldsPerProject;
		const currentFieldsCount = data?.projectConfiguration.limitInfo?.currentFieldsPerProject;

		return (
			typeof fieldsLimit === 'number' &&
			typeof currentFieldsCount === 'number' &&
			currentFieldsCount >= fieldsLimit
		);
	}

	return false;
};

type ConditionalTooltipProps = {
	shouldShowTooltip: boolean;
	children: ReactNode;
	tooltipContent: ReactNode;
};

export const ConditionalTooltip = ({
	shouldShowTooltip,
	children,
	tooltipContent,
}: ConditionalTooltipProps) => {
	if (shouldShowTooltip) {
		return (
			<>
				{/*
                    Since the menu will contain a disabled button, provide context to screen readers
                    why the user can't create RTs with templates.
                */}
				<VisuallyHidden>{tooltipContent}</VisuallyHidden>
				<Tooltip content={tooltipContent} position="right">
					{children}
				</Tooltip>
			</>
		);
	}

	return <>{children}</>;
};
